'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _typeUtils = require('../../utils/typeUtils');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function createReducer(initialState, descriptor) {
  if (!(0, _typeUtils.isValidObject)(descriptor)) {
    throw new Error('Expected a reducer description as an object.');
  }

  return function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];
    var handler = descriptor[action.type];

    if (!handler && !action.type) {
      console.warn('Handling an action without type: ' + (0, _stringify2.default)(action));
    }

    return handler && handler(state, action) || state;
  };
}

exports.default = createReducer;